import React from 'react';
import { Box } from '@mui/material';
export default function Index({
  color,
  size,
  width = '16px',
  height = '16px',
  ...other
}) {
  return (
    <Box
      component="svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      {...other}
      color={color ? color : 'primaryText'}
    >
      <path
        d="M12.3334 2.74005L9.00677 1.49338C8.45344 1.28671 7.54677 1.28671 6.99344 1.49338L3.66677 2.74005C2.9001 3.02671 2.27344 3.93338 2.27344 4.74671V9.70005C2.27344 10.4867 2.79344 11.52 3.42677 11.9934L6.29344 14.1334C7.23344 14.84 8.7801 14.84 9.7201 14.1334L12.5868 11.9934C13.2201 11.52 13.7401 10.4867 13.7401 9.70005V4.74671C13.7268 3.93338 13.1001 3.02671 12.3334 2.74005ZM7.95344 4.68671C8.7401 4.68671 9.3801 5.32671 9.3801 6.11338C9.3801 6.88671 8.77344 7.50671 8.00677 7.53338H7.99344H7.9801C7.96677 7.53338 7.95344 7.53338 7.9401 7.53338C7.1401 7.50671 6.5401 6.88671 6.5401 6.11338C6.53344 5.32671 7.17344 4.68671 7.95344 4.68671ZM9.4601 10.9067C9.05344 11.1734 8.52677 11.3134 8.0001 11.3134C7.47344 11.3134 6.9401 11.18 6.5401 10.9067C6.1601 10.6534 5.95344 10.3067 5.94677 9.92671C5.94677 9.55338 6.1601 9.19338 6.5401 8.94005C7.34677 8.40671 8.6601 8.40671 9.46677 8.94005C9.84677 9.19338 10.0601 9.54005 10.0601 9.92005C10.0534 10.2934 9.8401 10.6534 9.4601 10.9067Z"
        fill="currentColor"
      />
    </Box>
  );
}
